import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";

const {Text, Title} = Typography

export class FicheParents extends React.Component {

    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.parents.length === 0) {
            return null
        }

        return (
            <Col style={{marginBottom: 10}}>
                <Row style={{justifyContent: "flex-end"}}>
                    {selected.parents.map((p, k) => {
                        return (
                            <Button key={k} icon={<ContactIcon contact={p}/>} type="link"
                                    onClick={() => fiche.modalContact.show(p.id)}>{p.nom} {p.prenom}</Button>
                        )
                    })}
                </Row>
            </Col>
        )
    }
}
